import React from 'react';
import { Stack, DialogContent } from '@mui/material';

export default function NewDialogContent({ children, isPopup = false }) {
  return (
    <DialogContent sx={{ p: 0, height: '100%' }}>
      <Stack
        height={{
          sm: isPopup ? '50vh' : 'calc(100vh - 72px - 72px)',
          xs: isPopup ? '50vh' : 'calc(100vh - 72px - 72px - 72px)',
        }}
      >
        {children}
      </Stack>
    </DialogContent>
  );
}

// Footer -> 72px
// Header -> 72px
// NewDialogActions -> 72px
